import uniqBy from 'lodash/uniqBy';

export default function members(state = [], action) {
  switch (action.type) {
    case 'GET_MEMBERS_RESPONSE':
      return action.payload.members;
    case 'UPDATE_MEMBER_REQUEST':
    case 'UPDATE_MEMBER_ERROR':
      return state.map(member => {
        if (member.memberId === action.payload.member.memberId) return { ...member, ...action.payload.member };
        return member;
      });
    case 'DESTROY_MEMBER_REQUEST':
      return state.filter(({ memberId }) => memberId !== action.payload.memberId);
    case 'DESTROY_MEMBER_ERROR':
      return [...state, action.payload.member];
    case 'ADD_MEMBER_RESPONSE':
      return uniqBy([...state, ...action.payload.members], 'id');
    default:
      return state;
  }
}
